import styles from './StatusBadge.module.css';

interface StatusBadgeProps {
    status: string;
}

const STATUS_LABELS: Record<string, string> = {
    assigned: 'Asignado',
    submitted: 'Enviado',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    abandoned: 'Abandonado',
    pending: 'Pendiente',
};

export function StatusBadge({ status }: StatusBadgeProps) {
    return (
        <span className={`${styles.badge} ${styles[status] || ''}`}>
            {STATUS_LABELS[status] || status}
        </span>
    );
}
